// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import {FormattedMessage} from 'react-intl';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductInfoPanel from '../../shared/components/product-info-panel/product-info-panel';
import ProductRegistrationForm from './product-registration-form';
import RegistrationModals from '../state/registration-modals';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {secure} from '../../../shared/components/security-wrapper/secure';

function handleStatusChangeModalVisibility(isVisible) {

    this.actions.updateStatusChangeModalVisibility(isVisible);

}

function handleAmountOfUseModalClose() {

    this.actions.updateAmountOfUseModalVisibility(false);

}

function handleAmountOfUseModalOpen() {

    this.actions.updateAmountOfUseModalVisibility(true);

}

function handleModalVisibility(property, value) {

    this.actions.updateRegistrationModals(property, value);

}

function handleUpdateStatus() {

    this.actions.updateStatusChangeModalVisibility(false);
    this.actions.goToStatusChangeRequestView(this.product.pin);

}

function handleDeleteRegistration() {

    this.actions.deleteProductRegistration(this.registration.id);

}

function handleClosePrintRegistrationFormModal() {

    this.actions.closePrintRegistrationFormModal(this.registrationModals.printRegistrationFormModal.route);

}

function handlePrintRegistrationForm() {

    this.props.actions.printRegistrationForm(
        this.props.registrationModals.printRegistrationFormModal.registrationId,
        this.props.registrationModals.printRegistrationFormModal.route,
        this.context.user.settings.language.primaryLanguage.key
    );

}

class ProductRegistration extends Component {

    componentWillMount() {

        this.props.actions.updateDomainValues('otherUseUnits');
        this.props.actions.updateDomainValues('registrationTypes', this.props.queryParams.pin, this.props.queryParams.registrationId);

    }

    componentWillUnmount() {

        this.props.actions.updatePrintRegistrationFormModal(false, '#', '');
        this.props.actions.resetRegistration();
        this.props.actions.resetProductDetails();
        this.props.actions.updateRegistrationModals('confirmDeleteModal', false);
        this.props.actions.updateRegistrationModals('customerSearchModal', false);
        this.props.actions.updateStatusChangeModalVisibility(false);
        this.props.actions.resetFormValidation();
        this.props.actions.resetLatestPerUnitMeasurements();
        this.props.actions.updateAmountOfUseModalVisibility(false);

    }

    render() {

        return (
            <section className='new-registration'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.product.isNonTracked ?
                    <div className='help-text'>
                        <FormattedMessage id='NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT'/>
                    </div> :
                    <div>
                        {this.props.product.pin &&
                            <ProductInfoPanel
                                changeModalVisibility={this.props::handleStatusChangeModalVisibility}
                                isAmountOfUseModalOpen={this.props.isAmountOfUseModalOpen}
                                measurementReadings={this.props.measurementReadings}
                                onAmountOfUseModalClose={this.props::handleAmountOfUseModalClose}
                                onAmountOfUseModalOpen={this.props::handleAmountOfUseModalOpen}
                                product={this.props.product}
                                productStatusChangeModal={this.props.registrationModals.registrationStatusChangeModal}
                                updateStatus={this.props::handleUpdateStatus}
                            />
                        }
                    </div>
                }
                <ProductRegistrationForm/>
                <ConfirmationModal
                    confirmMessage='CONFIRM_DELETE_REGISTRATION'
                    isOpen={this.props.registrationModals.confirmDeleteModal}
                    onClose={handleModalVisibility.bind(this.props, 'confirmDeleteModal', false)}
                    onConfirm={this.props::handleDeleteRegistration}
                    title='DELETE_REGISTRATION'
                />
                <ConfirmationModal
                    confirmMessage='PRINT_REGISTRATION_FORM_MESSAGE'
                    isOpen={this.props.registrationModals.printRegistrationFormModal.isVisible}
                    onClose={this.props::handleClosePrintRegistrationFormModal}
                    onConfirm={{context: this.context, props: this.props}::handlePrintRegistrationForm}
                    title='PRINT_REGISTRATION_FORM'
                />
            </section>
        );

    }

}

ProductRegistration.displayName = 'ProductRegistration';
ProductRegistration.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    product: PropTypes.instanceOf(Product),
    queryParams: PropTypes.object.isRequired,
    registrationModals: PropTypes.instanceOf(RegistrationModals)
};
ProductRegistration.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default secure('PRT', 'PRT_REGISTER_PRODUCT')(ProductRegistration);



// WEBPACK FOOTER //
// ./src/product/product-registration/components/product-registration.js